export default function (v) {
  if (!v) return ''
  v = v.replace(/й/g, 'q')
  v = v.replace(/ц/g, 'w')
  v = v.replace(/у/g, 'e')
  v = v.replace(/к/g, 'r')
  v = v.replace(/е/g, 't')
  v = v.replace(/н/g, 'y')
  v = v.replace(/г/g, 'u')
  v = v.replace(/ш/g, 'i')
  v = v.replace(/щ/g, 'o')
  v = v.replace(/з/g, 'p')
  v = v.replace(/ф/g, 'a')
  v = v.replace(/ы/g, 's')
  v = v.replace(/в/g, 'd')
  v = v.replace(/а/g, 'f')
  v = v.replace(/п/g, 'g')
  v = v.replace(/р/g, 'h')
  v = v.replace(/о/g, 'j')
  v = v.replace(/л/g, 'k')
  v = v.replace(/д/g, 'l')
  v = v.replace(/я/g, 'z')
  v = v.replace(/ч/g, 'x')
  v = v.replace(/с/g, 'c')
  v = v.replace(/м/g, 'v')
  v = v.replace(/и/g, 'b')
  v = v.replace(/т/g, 'n')
  v = v.replace(/ь/g, 'm')

  v = v.replace(/Й/g, 'Q')
  v = v.replace(/Ц/g, 'W')
  v = v.replace(/У/g, 'E')
  v = v.replace(/К/g, 'R')
  v = v.replace(/Е/g, 'T')
  v = v.replace(/Н/g, 'Y')
  v = v.replace(/Г/g, 'U')
  v = v.replace(/Ш/g, 'I')
  v = v.replace(/Щ/g, 'O')
  v = v.replace(/З/g, 'P')
  v = v.replace(/Ф/g, 'A')
  v = v.replace(/Ы/g, 'S')
  v = v.replace(/В/g, 'D')
  v = v.replace(/А/g, 'F')
  v = v.replace(/П/g, 'G')
  v = v.replace(/Р/g, 'H')
  v = v.replace(/О/g, 'J')
  v = v.replace(/Л/g, 'K')
  v = v.replace(/Д/g, 'L')
  v = v.replace(/Я/g, 'Z')
  v = v.replace(/Ч/g, 'X')
  v = v.replace(/С/g, 'C')
  v = v.replace(/М/g, 'V')
  v = v.replace(/И/g, 'B')
  v = v.replace(/Т/g, 'N')
  v = v.replace(/Ь/g, 'M')
  return v
}
